import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Primary (cyan) and secondary (outline) buttons. Renders <Link> or <button>.
export function PrimaryButton({ to, onClick, children, type, variant = "primary", dark = false, className = "", ...rest }) {
  const base =
    "group inline-flex items-center justify-center gap-2 font-semibold text-sm px-7 py-4 transition-colors duration-300 clip-tag";
  const styles = {
    primary: "bg-cyan hover:bg-tech text-navy hover:text-white",
    outline: dark
      ? "border border-white/25 text-white hover:border-cyan hover:text-cyan bg-transparent"
      : "border border-ink/20 text-ink hover:border-tech hover:text-tech bg-transparent",
  };
  const inner = (
    <>
      {children}
      <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
    </>
  );
  const cls = `${base} ${styles[variant]} ${className}`;
  if (to) return <Link to={to} className={cls} {...rest}>{inner}</Link>;
  return <button type={type || "button"} onClick={onClick} className={cls} {...rest}>{inner}</button>;
}
